import { oc } from '@orpc/contract';
import { createTemplateInputSchema, templateDetailSchema } from '../schemas/templates.schemas.js';
/** Creates the template **and its first DRAFT version**, pre-filled from the starter preset. */
export const createTemplateContract = oc
    .route({
    method: 'POST',
    path: '/templates',
    tags: ['Templates'],
    summary: 'Create a template and its first draft version',
})
    .input(createTemplateInputSchema)
    .output(templateDetailSchema);
//# sourceMappingURL=create-template.contract.js.map